import { makeStyles } from "@mui/styles";

export const useSearchInputStyles = makeStyles(() => ({
    root: {},
}));
